import pl from './pl.json'
import en from './en.json'

export default {
	en,
	pl,
} as { [key: string]: Record<string, string> }
